import * as React from 'react';
import './pharmacy.less';
import {
    Value,
    Values,
} from 'one-ui-values';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';

import {
    PharmaciesModel
} from './model';

import {
    buildGearActionsMenu,
} from 'one-ui-gear/src/actions';

import {
    CardNoData
  } from 'one-ui-card';

import {
    PharmaciesCardProps
} from './props';

import {
    CardLight,
} from 'one-ui-card/src/card-light';

import Skeleton from 'antd/lib/skeleton';

import {
    checkCardHasError,
    CardErrorMsg,
    CardLockIcon
} from 'one-card-notification';
import { useCtx } from "one-ui-provider";
import {FinessePhonePlugin} from 'one-comp-phone'
/**
 * This function returns the Patient Pharmacy
 * @param props component property
 * @returns JSX code Patient Pharmacy Card
 */
export const PharmaciesCard = <M extends PharmaciesModel>(
    props: PharmaciesCardProps<M>
) => {
    const {
        model,
        title,
        gearActions = [],
        skeleton,
    } = props;
    const {
        pharmacydata
    } = model || {};
    const {
        pharmacies_skeleton,
    } = skeleton;
    const { settings } = useCtx();
    const { uisettings: { dashboardcardconfig } } = settings;
    let defaultUI = [<div ></div>];
    let pharmacyUI:any = [];
   
    //initial value to be overwritten on values found
    pharmacyUI.push(
        <Row>
            <Col>
                <Values>
                    <Value label="Preferred Pharmacy Name" value="" />
                </Values><br/>
            </Col>
            <Col>
                <Values>
                    <Value label="Pharmacy Number" value="" />
                </Values>
                <br />
            </Col>
        </Row>
    )
    if ((pharmacydata?.[0]?.pharmacyname) && (pharmacydata[0].pharmacynumber)) {
        for (const pharmacyIndex in pharmacydata) {
            defaultUI.push(
                <Row>
                    <Col>
                        <Values>
                            <Value label="Preferred Pharmacy Name" value={pharmacydata[pharmacyIndex].pharmacyname} />
                        </Values><br/>
                    </Col>
                    <Col>
                    <FinessePhonePlugin 
                          label='Contact Number'
                          phone={pharmacydata[pharmacyIndex].pharmacynumber}
                       />
                        <br />
                    </Col>
                </Row>
            )
        }
       pharmacyUI = [<div className="pharmacyfield" >{defaultUI}</div>];
    }
    //Chech for No Data
    else if(pharmacydata && Object.keys(pharmacydata).length === 0 && pharmacydata.constructor === Object) {
        pharmacyUI = (
            <CardNoData />
        )
    }

    // If Pharmacy skeleton is true
    if (pharmacies_skeleton) {
        pharmacyUI = (<Skeleton active paragraph={{ rows: 1 }} />);
    }
    //Check for error
    if(checkCardHasError('Pharmacies') && 
       (pharmacydata && Object.keys(pharmacydata).length === 0 && pharmacydata.constructor === Object)){
        pharmacyUI = (<CardErrorMsg />)
    }

    // Based on pharmacies flag If pharmacies flag set as false then Lock Icon Will Show
    if (!dashboardcardconfig?.pharmacies){
        pharmacyUI = 
        <>
            <CardLockIcon />
        </>
        return (
            <CardLight
                title={title}
                body={(
                    <div >
                    {pharmacyUI}
                    </div>
                )}
            />
        )
    }
    else {
        return (
            <CardLight
                title={title}
                gearActions={
                    buildGearActionsMenu(
                        gearActions,
                    )
                }
                body={(
                    <div >
                    {pharmacyUI}
                    </div>
                )}
            />
        )
    }
}
